export const formatDistance = (
  distance: number,
  options?: { precision: number },
) => {
  const { precision = 1 } = options || {};

  return parseFloat((distance / 1000).toFixed(precision));
};
